import Vue from "vue";
import Router from "vue-router";
import { authService } from './service/authService'
//import mainAuth from "./plugins/auth";
import store from "@/store/store.js";


const Page404 = () => import("@/views/error/Page404");
const Page403 = () => import("@/views/error/Page403");
const Login = () => import("@/views/Login.vue");
const ContractList = () => import("@/views/pages/company/contractList.vue");
const FactorsList = () => import("@/views/pages/company/factorsList.vue");
const FactorsList99 = () => import("@/views/pages/company/factorsList99.vue");
const FactorsList98 = () => import("@/views/pages/company/factorsList98.vue");
const FactorsList01 = () => import("@/views/pages/company/factorsList01.vue");
const RackList = () => import("@/views/pages/company/rackList.vue");
const RackList403 = () => import("@/views/pages/company/rackList403.vue");
const ContractsList01 = () => import("@/views/pages/company/contractList01.vue");

const ContractsList1400 = () => import("@/views/pages/company/contractList1400.vue");
const ContractsList1401 = () => import("@/views/pages/company/contractList1401.vue");
const ContractsList1402 = () => import("@/views/pages/company/contractList1402.vue");
const ContractsList1403 = () => import("@/views/pages/company/contractList1403.vue");


const ContractsList02 = () => import("@/views/pages/company/contractList02.vue");
Vue.use(Router);

const router = new Router({
  mode: "history",
  //base: process.env.BASE_URL,
  routes: configRoutes()
});

//mainAuth.useRouter(router);
router.beforeEach(async (to, from, next) => {
  if (to.meta.error || to.matched.some(parent => parent.meta.error)){
    return next()
  }
  if ((to.meta.guest || to.matched.some(parent => parent.meta.guest)) && authService().existToken()){
    return next({ name: 'Dashboard' })
  }
  if ((to.meta.auth || to.matched.some(parent => parent.meta.auth)) && !authService().existToken()) {
    return next({ name: 'Login' })
  }
  console.log(authService().existToken())
  // if(authService().existToken()){
  //   return next()
  // }else{
  //   return next({ name: 'Login' })
  // }

  //store.dispatch('auth/logout')
  //console.log(authService().existToken())
  // if (to.meta.error || to.matched.some(parent => parent.meta.error)){
  //   return next()
  // }
  // if ((to.meta.guest || to.matched.some(parent => parent.meta.guest)) && authService().existToken()){
  //   return next({ name: 'Dashboard' })
  // }
  //
  // if ((to.meta.auth || to.matched.some(parent => parent.meta.auth)) && !authService().existToken()) {
  //   return next({ name: 'Login' })
  // }
  // if(authService().existToken()){
  //   let userInfo = store.getters["userInfo/getUserInfo"];
  //   //console.log("userInfo",userInfo);
  //   if(!userInfo){
  //     userInfo = await store.dispatch("userInfo/fetchUserInfo")
  //     //console.log("userInfo",userInfo);
  //   }
  //   if(userInfo.role != to.meta.role){
  //     //console.log()
  //     return next({ name: 'Page403' })
  //   }
  // }

  return next()
})


export default router;

function configRoutes() {
  return [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        guest: true,
      },
      // beforeEnter: (to, from, next) => {
      //  // mainAuth.isAuthenticated ? next({name: "Dashboard"}) : next();
      // }
    },
    {
      path: "/",
      component: () => import("@/views/dashboard/Index"),
      meta: {
        auth: true,
      },
      children: [
        {
          name: "Dashboard",
          path: "",
          component: () => import("@/views/dashboard/Dashboard"),
          meta:{
            role:'superAdmin'
          }
        },

        {
          path: "/contracts-list",
          name: "ContractList",
          component: ContractList,
          meta:{
            role:'superAdmin'
          }
        },
        {
          path: "/factors-list/:id",
          name: "FactorsList",
          component: FactorsList,
          meta:{
            role:'superAdmin'
          }
        },
        {
          path: "/factors-list-99",
          name: "FactorsList99",
          component: FactorsList99,
          meta:{
            role:'superAdmin'
          }
        },
        {
          path: "/factors-list-98",
          name: "FactorsList98",
          component: FactorsList98,
          meta:{
            role:'superAdmin'
          }
        },
        {
          path: "/factors-list-01",
          name: "FactorsList01",
          component: FactorsList01,
          meta:{
            role:'superAdmin'
          }
        },
        {
          path: "/rack-list/:id",
          name: "RackList",
          component: RackList,
          meta:{
            role:'superAdmin'
          }
        },
        {
          path: "/rack-list-403/:id",
          name: "RackList403",
          component: RackList403,
          meta:{
            role:'superAdmin'
          }
        },
        {
          path: "/contracts-list-01",
          name: "ContractsList01",
          component: ContractsList01,
          meta:{
            role:'superAdmin'
          }
        },
        {
          path: "/contracts-list-02",
          name: "ContractsList02",
          component: ContractsList02,
          meta:{
            role:'superAdmin'
          }
        },
        {
          path: "/contracts-list-1400",
          name: "ContractsList1400",
          component: ContractsList1400,
          meta:{
            role:'superAdmin'
          }
        },
        {
          path: "/contracts-list-1401",
          name: "ContractsList1401",
          component: ContractsList1401,
          meta:{
            role:'superAdmin'
          }
        },
        {
          path: "/contracts-list-1402",
          name: "ContractsList1402",
          component: ContractsList1402,
          meta:{
            role:'superAdmin'
          }
        },
        {
          path: "/contracts-list-1403",
          name: "ContractsList1403",
          component: ContractsList1403,
          meta:{
            role:'superAdmin'
          }
        },
      ]
    },
    {
      path: "/error",
      redirect: "/error/404",
      name: "Error",
      meta:{
        error:true
      },
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404
        },
        {
          path: "500",
          name: "Page500",
          component: Page404
        },
        {
          path: "403",
          name: "Page403",
          component: Page403
        }
      ]
    },
    {path: "*", redirect: "/error/404"}
  ];
}

async function checkRole(next, shouldSuper) {
  next()

}
